import { render as cliAndCodeReviewRender } from './variants/cli-and-code-review';
import { render as cliRender } from './variants/cli';
import { render as codeReviewRender } from './variants/code-review';
import { createRender, type HydrationResult } from './types';
import {
	DEFAULT_VARIANT,
	VARIANT_CLI,
	VARIANT_CODE_REVIEW,
	VARIANT_CLI_AND_CODE_REVIEW,
} from '../../../constants';
import { type JSX } from 'react/jsx-runtime';

type VariantRender = typeof cliRender;

/**
 * Main render function that selects the appropriate variant based on variantType from hydration.
 * Since placement already filters messages via Narrow Exposure check, if we reach render,
 * we should always show a message. Uses DEFAULT_VARIANT as fallback if variantType is null.
 */
export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(
	({
		variantType,
		tenantId,
		accountId,
		onDismissed,
	}: {
		variantType: HydrationResult['variantType'];
		tenantId: string;
		accountId: string;
		onDismissed?: () => void;
	}) => {
		// Use default variant if variantType is null (defensive fallback)
		// Since placement already filtered, we should always render something
		const variant = variantType ?? DEFAULT_VARIANT;

		// Variant renders include tenantId and accountId for analytics tracking
		// Type assertion needed because not all variants accept these props yet
		const props = {
			variantType: variant,
			tenantId,
			accountId,
			onDismissed: onDismissed ?? (() => {}),
		} as Parameters<VariantRender>[0];

		switch (variant) {
			case VARIANT_CLI:
				return cliRender(props);
			case VARIANT_CODE_REVIEW:
				return codeReviewRender(props);
			case VARIANT_CLI_AND_CODE_REVIEW:
				return cliAndCodeReviewRender(props);
		}
	},
);

export default render;
